import { forwardRef } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  padding: 32px;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
  border: none;
  border-radius: 30px;
  background: ${({ active }) =>
    active
      ? 'var(--white-shades-white-100, #FFF)'
      : 'var(--secoundary-secoundary-300, #DF76BB)'};
  transition: background 0.5s ease;

  p {
    color: ${({ active }) =>
      active
        ? 'var(--font-color-font-1, #1B131F)'
        : 'var(--font-color-font-4, #FFF)'};
    text-align: justify;
    font-family: Instrument Sans;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
  }

  .author {
    display: flex;
    align-items: center;
    gap: 32px;
    align-self: stretch;

    img {
      border-radius: 215.139px;
      width: 54px;
      height: 54px;
    }

    p {
      font-size: 20px;
      line-height: 28px;
    }
  }

  @media screen and (max-width: 1024px) {
    padding: 1.5rem;
    gap: 1rem;
    p {
      font-size: 18px;
      line-height: 28px;
    }

    .author {
      display: flex;
      align-items: flex-start;
      gap: 1.5rem;
      align-self: stretch;

      img {
        border-radius: 215.139px;
        width: 54px;
        height: 54px;
      }

      p {
        font-size: 18px;
        line-height: 28px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    flex-shrink: 0;
    padding: 1.25rem 1.5rem;
    gap: 16px;

    p {
      font-size: 18px;
      line-height: 26px;
    }

    .author {
      p {
        font-size: 18px;
        line-height: 26px;
      }
    }
  }
`;

const ReviewCard = forwardRef(
  (
    {
      author,
      shop = '',
      content,
      icon,
      alt = 'Floral website builder who build their Floral e-commerce website using BoostFloral',
      active = false,
    },
    ref,
  ) => {
    return (
      <Wrapper active={active} ref={ref}>
        <p>{content}</p>
        <div className="author">
          <img loading="lazy" src={icon} alt={alt} />
          <div>
            {' '}
            <p>{author}</p>
            <p>{shop}</p>
          </div>
        </div>
      </Wrapper>
    );
  },
);

export default ReviewCard;
